const CheckboxLabel = ({ children }: { children: React.ReactNode }) => {
  return (
    <span className="font-sans text-xs normal-case leading-3">
      {children}
    </span>
  )
}

export default CheckboxLabel
